import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import history from 'src/history'

// Components
import ThumbsUpAndDownOption from './ThumbsUpAndDownOption'

// Selectors
import { hasCustomerToken } from 'src/auth'
import { selectClientFetchId } from 'src/store/selectors/client'
import { selectHomeId } from 'src/store/selectors/home'

// Actions
import { handleAcknowledgeTuneValue } from 'src/actions/homeowner'

// Utils
import { PATH_HELPERS } from 'src/constants/navigation'
import { dispatchEvent } from 'src/helpers/tagManager'
import {
  LowConfidenceWarnLoad,
  LowConfidenceWarnTuneClick,
  LowConfidenceLooksGoodClick,
  LowConfidenceThumbsDownClick
} from 'src/constants/trackingEvents'

const propTypes = { setForceHide: PropTypes.func }

const LowConfidenceToolTipWarning = ({ setForceHide }) => {
  const dispatch = useDispatch()

  const [thumbsDown, setThumbsDown] = useState(false)

  const clientId = useSelector(selectClientFetchId)
  const homeId = useSelector(selectHomeId)

  const handleLooksGood = () => {
    setForceHide(true)
    if (hasCustomerToken()) return

    dispatchEvent(LowConfidenceLooksGoodClick)
    dispatch(handleAcknowledgeTuneValue())
  }

  const handleThumbsDown = () => {
    dispatchEvent(LowConfidenceThumbsDownClick)
    setThumbsDown(true)
  }

  const handleTuneYourValue = () => {
    dispatchEvent(LowConfidenceWarnTuneClick)
    history.push(PATH_HELPERS.tuneYourValue.buildPath(clientId, homeId))
  }

  useEffect(() => {
    dispatchEvent(LowConfidenceWarnLoad)
  }, [])

  return (
    <>
      <ThumbsUpAndDownOption
        lowConfidence
        handleThumbsUpClick={handleLooksGood}
        handleThumbsDownClick={handleThumbsDown}
        handleTuneYourValue={handleTuneYourValue}
        showAnsweredMessage={thumbsDown}
      />
    </>
  )
}

LowConfidenceToolTipWarning.propTypes = propTypes
export default LowConfidenceToolTipWarning
